import { Injectable } from '@angular/core';
import { GungMainMenuService, GungMenu } from 'gung-standard';

@Injectable({
  providedIn: 'root'
})
export class CarLinerGungMainMenuService extends GungMainMenuService {
  override mountMenu(user: any, roles: string[], selectedCustomer: any, features: any, menuConfig: any): GungMenu[] {
    let mainMenu = super.mountMenu(user, roles, selectedCustomer, features, menuConfig);

    if (roles.includes('END_USER')) {
      for (const menu of mainMenu) {
        menu.links = (menu.links || []).filter(link => link.link !== '/products-export');
      }
    }

    // Plain users (no SALES/ADMIN/DISTRIBUTOR) only ever had these links in the old navbar's
    // user menu (CarLinerNavbarConfigService.getUserMenu, removed when migrating to the new navbar).
    const isUser =
      roles.includes('USER') && !roles.includes('SALES') && !roles.includes('ADMIN') && !roles.includes('DISTRIBUTOR');
    if (isUser) {
      const allowedLinks = ['/selected-customer', '/products-export', '/carts', '/favourites', '/news'];
      mainMenu = mainMenu.filter(menu => menu.heading !== 'HIDE_PRICE');
      for (const menu of mainMenu) {
        menu.links = (menu.links || []).filter(link => allowedLinks.includes(link.link));
      }
      mainMenu = mainMenu.filter(menu => menu.links.length > 0);
    }

    return mainMenu;
  }
}
